import {z} from 'zod';
import {ELEMENT} from '../../elements/base/ElementTypes';
import {removeHtmlTagsAndSpacesAndReturnLength} from '../../utils/utils';

export const MAX_TEXT_LENGTH = 1500;

export const staticTextValidator = z.object({
    type: z.literal(ELEMENT.STATIC_TEXT),
    text: z.string().refine((text) => removeHtmlTagsAndSpacesAndReturnLength(text) <= MAX_TEXT_LENGTH, `text;max;${MAX_TEXT_LENGTH}`),
});
